import { updateConditionDisplayOptionAction as updateConditionDisplayOptionOperation } from 'editor/src/store/design/slice';

export default updateConditionDisplayOptionOperation;
